import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { IdentificationTypeResponse } from '../../TeacherManagement/TeacherActivation/types';
import { getIdentificationTypes } from '../api/studentPersonalInfoRequests';

interface IdentificationTypeLoaderProps {
  children: (props: {
    identificationTypeSelect: { value: string; label: string }[];
    refresh: () => Promise<void>;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  IdentificationTypeResponse
>();

export function useIdentificationTypeLoader() {
  return useFetch();
}

export const BaseLoaderConsumer = FetchConsumer;

export default function IdentificationTypeLoader({
  children,
}: IdentificationTypeLoaderProps) {
  const request = useCallback(() => {
    return getIdentificationTypes();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({
            identificationTypeSelect: (data?.identificationTypes ?? []).map(
              (identificationType) => ({
                value: identificationType.id,
                label: identificationType.name,
              }),
            ),
            refresh,
          });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
